module.exports = __webpack_public_path__ + "media/images/product/p_m-c64bd72f0c22cd0169ea5a7531d7bb38.png";